
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { AuthImage, AuthView } from '@Components/Auth/Auth.styled';
import Dialogue from '@Components/Auth/Dialogue';
import Layout from '@Components/Layout';
import { RIA } from '@Constants/ACL';
import { NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';
import React, { useState } from 'react';
import { Col, Container, Row } from 'styled-bootstrap-grid';
type Props = {};

const SignupForm = dynamic(() => import('@Components/Auth/SignupForm'));

const RegisterPage: NextPage = ({}: Props) => {
  const { t: tAuth } = useTranslation('Auth');
  const [isFormSuccess, setIsFormSuccess] = useState<boolean>(false);

  return (
    <Layout
      seoData={{
        title: tAuth('register'),
      }}
      hideNavbar={true}
    >
      <AuthView>
        <AuthImage />
        <Container fluid>
          <Row justifyContent="end">
            <Col col={12} xxl={5} xl={6} lg={8}>
              <SignupForm setIsFormSuccess={setIsFormSuccess} />
              {isFormSuccess && (
                <Dialogue
                  title={tAuth('thanks')}
                  message={tAuth('signup_success')}
                  cta={{
                    message: tAuth('sign_in'),
                    link: '/auth/login',
                  }}
                />
              )}
            </Col>
          </Row>
        </Container>
      </AuthView>
    </Layout>
  );
};

 async function _getStaticProps() {
  return {
    props: {
      ACL: {
        action: RIA,
      },
    },
  };
}

export default RegisterPage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/auth/register',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  